const reportParameterTypes = {
  boolean: 0,
  dateTime: 1,
  integer: 2,
  float: 3,
  string: 4,
};

export default reportParameterTypes;
